import { RadioGroup } from '@/shared/ui/forms/inputs/radio'

import { type FC } from 'react'

import { useLanguageSelectorPanel } from './useLanguageSelectorPanel'

/**
 * LanguageSelectorPanel - Language switching tab for the TestingPanel.
 *
 * Displays available languages as a RadioGroup for single-selection.
 * Includes a "Dev Mode" option that replaces all translations with their keys,
 * useful for identifying missing or misused translation strings.
 *
 * Meant to be embedded inside the TestingPanel — has no floating wrapper.
 *
 * @example
 * ```tsx
 * <LanguageSelectorPanel />
 * ```
 */
export const LanguageSelectorPanel: FC = () => {
  const { languages, selectedLanguage, handleLanguageChange } = useLanguageSelectorPanel()

  return (
    <div className="flex flex-col gap-3">
      <RadioGroup value={selectedLanguage} onChange={handleLanguageChange}>
        {languages.map(lang => (
          <RadioGroup.Option key={lang.code} value={lang.code}>
            <span aria-hidden="true">{lang.flag}</span>
            <span>{lang.label}</span>
          </RadioGroup.Option>
        ))}
      </RadioGroup>
    </div>
  )
}
